// extracted by css-extract-rspack-plugin
export default {"root":"Pill-module__root___Ryahu","label":"Pill-module__label___Npz1m","remove":"Pill-module__remove___VKiaS"};